import React from "react";
// import { TbDragDrop2 } from "react-icons/tb";
import { Element } from "@craftjs/core";
import { CategoryCardTabList } from "components/CategoryCardTabList";
import { Box, Button, H1, Text } from "components/ui";
import { PageContainer } from "./PageContainer";
import { PageText } from "./PageText";
import Container from "components/general/Container";
import { useIsMobile } from "utils/hooks/useIsMobile";
import Breadcrumbs from "components/general/Breadcrumbs";
import CollapsibleText from "components/general/CollapsibleText";

export const HeaderTitle = ({ ...props }) => {
	return <Box>{props.children}</Box>;
};

export const HeaderDescription = ({ ...props }) => {
	return <Box>{props.children}</Box>;
};

export const PageHeader = () => {
	const isMobile = useIsMobile();
	return (
		<Container>
			<Box
				sx={{
					paddingHorizontal: 16,
					"@md": {
						paddingHorizontal: 48,
					},
				}}
				paddingVertical={32}
			>
				<Box pb={20}>
					<Breadcrumbs />
				</Box>
				{/* <H1
				sx={{
					paddingBottom: 16,
					"@md": {
						paddingBottom: 20,
						lineHeight: 48,
					},
				}}
			> */}
				<Element is={HeaderTitle} id="title" data-cy="header-title-container"></Element>
				{/* {HeaderDescription && <Element is={HeaderDescription} id="description" data-cy="header-description-container"></Element>} */}

				{/* {description ? <CollapsibleText text={description} /> : null} */}
			</Box>
		</Container>
	);
};
